export default __webpack_public_path__ + "static/media/plaid.6615eaf9.jpg";